import React from "react"
import styled from "styled-components"
import { colors } from "../utils/siteVars"
import Loader from "./loader"

const StyledLoaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  height: 100vh;
  width: 100vw;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10;
  pointer-events: none;
  opacity: 0;
  transition: 200ms ease-in-out;
  &.active {
    opacity: 1;
  }
`

const LoaderContainer = props => {
  return (
    <StyledLoaderContainer className={props.active ? "active" : ""}>
      <Loader color={colors.white} dualRing />
    </StyledLoaderContainer>
  )
}

export default LoaderContainer
